var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 24 24",
    width: 48,
    height: 48,
    "aria-label": "Wyko\\u0144czenie i wysy\\u0142ka",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#52d552",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5,
    width: 13,
    height: 11,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9h13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16v1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.5a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16v-4h2.5l1.5 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 18.5a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.2d3465db7796ded328723b71311c52a5.svg";
export { ForwardRef as ReactComponent };